/* /precons — the browser half of the precon hub.
 * The server rendered every precon as a link, grouped by release (pages/precons.php), with the newest
 * releases showing. Here: "show older releases", and search / color identity / release / sort, which
 * switch to one flat grid of the matching tiles (cloned from the grouped ones). State lives in the URL.
 */
import "../lib/site.js";

(function () {
  "use strict";

  var KD = window.KD;
  var setsBox = KD.$("[data-sets]"), flat = KD.$("[data-flat]"), none = KD.$("[data-none]"), pager = KD.$("[data-pager]"), countEl = KD.$("[data-count]");
  if (!setsBox || !flat || !pager) return;
  var groups = KD.$$("[data-set-group]", setsBox);
  var tiles = KD.$$(".ptile", setsBox);
  // what search looks at: deck name, commander, release name and set code, as shown on the tile
  tiles.forEach(function (t) {
    var txt = function (s) { var x = KD.$(s, t); return x ? x.textContent : ""; };
    t._name = txt(".dcard__name").toLowerCase();
    t._hay = [t._name, txt(".dtile__cmd"), txt(".dtile__by"), t.getAttribute("data-set")].join(" ").toLowerCase();
  });
  var qEl = KD.$("[data-q]"), setEl = KD.$("[data-setsel]"), sortEl = KD.$("[data-sort]"), colorsBox = KD.$("[data-colors]");
  var SET_STEP = 8, FLAT_STEP = 36;
  var defaultCount = countEl ? countEl.textContent : "";
  var st = { q: "", colors: "", set: "", sort: "new", sets: groups.filter(function (g) { return !g.hidden; }).length, flat: FLAT_STEP };

  function isDefault() { return !st.q && !st.colors && !st.set && st.sort === "new"; }
  function words(q) { return q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 0; }); }

  function matches() {
    var ws = words(st.q), cols = st.colors.split("").filter(Boolean);
    var list = tiles.filter(function (t) {
      var hay = t._hay, c = t.getAttribute("data-colors") || "";
      for (var i = 0; i < ws.length; i++) if (hay.indexOf(ws[i]) === -1) return false;
      for (var j = 0; j < cols.length; j++) {
        if (cols[j] === "C" ? c !== "" : c.indexOf(cols[j]) === -1) return false;
      }
      return !st.set || t.getAttribute("data-set") === st.set;
    });
    list.sort(function (a, b) {
      if (st.sort === "name") return a._name.localeCompare(b._name);
      var cmp = a.getAttribute("data-released").localeCompare(b.getAttribute("data-released"));
      return (st.sort === "old" ? cmp : -cmp) || a._name.localeCompare(b._name);
    });
    return list;
  }

  function moreBtn(label) {
    return '<a class="btn btn--ghost" href="/precons?all=1" data-more>' + label + "</a>";
  }

  function render() {
    if (isDefault()) {
      flat.hidden = true;
      flat.innerHTML = "";
      setsBox.hidden = false;
      none.hidden = true;
      groups.forEach(function (g, i) { g.hidden = i >= st.sets; });
      var left = groups.length - st.sets;
      pager.innerHTML = left > 0 ? moreBtn("Show older releases <small>" + left + " more</small>") : "";
      if (countEl) countEl.textContent = defaultCount;
      return;
    }
    var list = matches();
    setsBox.hidden = true;
    none.hidden = list.length > 0;
    flat.hidden = !list.length;
    var frag = document.createDocumentFragment();
    list.slice(0, st.flat).forEach(function (t) { frag.appendChild(t.cloneNode(true)); });
    flat.innerHTML = "";
    flat.appendChild(frag);
    var left = list.length - st.flat;
    pager.innerHTML = left > 0 ? moreBtn("Show more precons <small>" + left + " more</small>") : "";
    if (countEl) {
      countEl.textContent = list.length + (list.length === 1 ? " precon" : " precons") + (st.q ? " match “" + st.q + "”" : (st.set || st.colors ? " match" : ""));
    }
  }

  function syncUrl() {
    var p = new URLSearchParams();
    if (st.q) p.set("q", st.q);
    if (st.colors) p.set("c", st.colors);
    if (st.set) p.set("set", st.set);
    if (st.sort !== "new") p.set("sort", st.sort);
    var qs = p.toString();
    try { history.replaceState(null, "", "/precons" + (qs ? "?" + qs : "")); } catch (e) { /* ignore */ }
  }

  var gaTimer = 0;
  function apply(reason) {
    st.flat = FLAT_STEP;
    render();
    syncUrl();
    clearTimeout(gaTimer);
    gaTimer = setTimeout(function () { KD.ga("precons_filter", { reason: reason, q: st.q, colors: st.colors, set: st.set, sort: st.sort }); }, 1200);
  }

  function paintColors() {
    KD.$$("[data-color]", colorsBox).forEach(function (b) {
      var on = st.colors.indexOf(b.getAttribute("data-color")) !== -1;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", String(on));
    });
  }

  // ---------------------------------------------------------------- initial state from the URL
  var params = new URLSearchParams(location.search);
  st.q = (params.get("q") || "").trim().slice(0, 80);
  st.colors = "WUBRGC".split("").filter(function (c) { return (params.get("c") || "").toUpperCase().indexOf(c) !== -1; }).join("");
  var wantSet = (params.get("set") || "").toUpperCase();
  if (wantSet && setEl && KD.$$("option", setEl).some(function (o) { return o.value === wantSet; })) st.set = wantSet;
  st.sort = ["old", "name"].indexOf(params.get("sort")) !== -1 ? params.get("sort") : "new";
  if (params.get("all")) st.sets = groups.length;
  if (qEl) qEl.value = st.q;
  if (setEl) setEl.value = st.set;
  if (sortEl) sortEl.value = st.sort;
  paintColors();
  if (!isDefault()) render();

  // ---------------------------------------------------------------- controls
  var qTimer = 0;
  if (qEl) qEl.addEventListener("input", function () {
    clearTimeout(qTimer);
    qTimer = setTimeout(function () { st.q = qEl.value.trim().slice(0, 80); apply("search"); }, 140);
  });
  var form = KD.$("[data-psearch]");
  if (form) form.addEventListener("submit", function (e) {
    e.preventDefault();
    clearTimeout(qTimer);
    st.q = qEl.value.trim().slice(0, 80);
    apply("search");
    if (KD.mobile()) qEl.blur();
    var top = KD.$(".ptools");
    if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.pageYOffset - 90, behavior: KD.reduce ? "auto" : "smooth" });
  });
  if (colorsBox) colorsBox.addEventListener("click", function (e) {
    var b = e.target.closest("[data-color]");
    if (!b) return;
    var c = b.getAttribute("data-color");
    st.colors = st.colors.indexOf(c) !== -1 ? st.colors.replace(c, "") : "WUBRGC".split("").filter(function (x) { return x === c || st.colors.indexOf(x) !== -1; }).join("");
    paintColors();
    apply("colors");
  });
  if (setEl) setEl.addEventListener("change", function () { st.set = setEl.value; apply("set"); });
  if (sortEl) sortEl.addEventListener("change", function () { st.sort = sortEl.value; apply("sort"); });

  pager.addEventListener("click", function (e) {
    var a = e.target.closest("[data-more]");
    if (!a) return;
    e.preventDefault();
    if (isDefault()) st.sets += SET_STEP; else st.flat += FLAT_STEP;
    render();
  });

  var reset = KD.$("[data-reset]");
  if (reset) reset.addEventListener("click", function () {
    st.q = ""; st.colors = ""; st.set = ""; st.sort = "new";
    if (qEl) qEl.value = "";
    if (setEl) setEl.value = "";
    if (sortEl) sortEl.value = "new";
    paintColors();
    apply("reset");
  });

  document.addEventListener("click", function (e) {
    var t = e.target.closest(".ptile");
    if (t) KD.ga("precons_open", { deck: (t.getAttribute("href") || "").split("deck=")[1] || "", filtered: !isDefault() });
  });
})();
